<div class="tire-connect-detail-dialog flex-column flex-start">
  <div class="tire-detail-header flex-row flex-between">
    <div class="flex-between-center">
      <img *ngIf="source === 'tireconnect'" src="assets/img/tireConnect-logo.png" alt="TireConnect Logo" class="mr-1" />
      <img *ngIf="source === 'tirehub'" src="assets/img/Tirehub_Logo.svg" alt="TireHub Logo" class="mr-1" />
      <span class="font-18 font-700">Tire Details</span>
    </div>

    <span class="font-16 font-300">
      <i class="fal fa-times pointer" (click)="handleClose()"></i>
    </span>
  </div>

  <div class="tire-detail-body flex-row flex-start w-100">
    <div class="tire-img-secton flex-column flex-start">
      <div class="tire-detail-img flex-center-center">
        <!-- <img [src]="singleImage || 'assets/img/tire-connect-detail.png'"/> -->
        <div class="wiring-wrapper flex-center-center">
          <div class="rd-image-details tech-diagram-wrapper flex-center-center bg-white">
            <div class="rd-wiring-name-content">
              <div class="image-viewer-counter-wrapper" *ngIf="documentUrls?.length > 1">
                <span class="font-18 font-gray-45 font-600">{{imageIndex + 1}} of {{documentUrls?.length}}</span>
              </div>

              <angular-image-viewer (indexChange)="handleIndexChangeEvent($event)" *ngIf="documentUrls?.length"
                [src]="documentUrls" [(index)]="imageIndex" [config]="config">
              </angular-image-viewer>
            </div>
          </div>
        </div>
      </div>

      <div class="tire-detail-horizontal flex-row mt-2" [hidden]="!imagesArray?.length">
        <div class="left-scroll flex-center-center position-absolute left-pos pointer" [hidden]="imagesArray?.length <= 3" (click)="slideImage('prev')">
          <i class="fa fa-angle-left font-16 font-400"></i>
        </div>

        <div class="right-scroll flex-center-center position-absolute right-pos pointer" [hidden]="imagesArray?.length <= 3" (click)="slideImage('next')">
          <i class="fa fa-angle-right font-16 font-400"></i>
        </div>

        <div #imagesContent class="tire-img-scroll flex-row"
          [ngClass]="imagesArray?.length > 3 ? 'flex-between-end' : 'flex-center-center'">
          <ng-container *ngFor="let img of imagesArray; let idx=index;">
            <div class="scroll-img mr-2 flex-between-center pointer" [ngClass]="img?.active ? 'active-div': ''"
              (click)="enlageImage(img, idx)">
              <img [src]="img?.imageSrc" #imgCont (error)="handleUpdateTireImage(imgCont)" />
            </div>

          </ng-container>
        </div>
      </div>
    </div>
    <div class="tire-specs-section flex-column flex-start w-100 pl-3">
      <div class="tire-spec-header flex-row flex-between-start border-bottom-lightest pb-2">
        <div class="flex-column">
          <span class="font-16 font-700">{{tire?.title}}</span>
          <span class="font-14 font-400">{{tire?.brand}}</span>
        </div>

        <div class="flex-row flex-start">
          <div class="flex-column mr-3" [hidden]="hideCost">
            <span class="font-12 font-400 font-secondary">Cost (per tire)</span>
            <span class="font-18 font-700 flex-end-start">{{tire?.cost | currency: usd}}</span>
          </div>
          <div class="flex-column" *ngIf="isOpenFromQuickTireLookup || isOpenFromRO">
            <span class="font-12 font-400 font-secondary">Price (per tire)</span>
            <span class="font-18 font-primary font-700 flex-end-start">{{tire?.price | currency: usd}}</span>
          </div>
        </div>
      </div>
      <div class="tire-spec-body flex-column mt-3">
        <span class="font-14 font-600">Detailed Specification</span>
        <div class="flex-row pt-2 flex-between-start">
          <div class="flex-start-start flex-wrap w-100">
            <div class="flex-column ui-g-4" *ngFor="let spec of tire?.specifications">
              <span class="font-14 font-secondary">{{spec?.label}}</span>
              <span class="font-14 font-600">{{spec?.value}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="border-top-lightest flex-end-start flex-row tire-detail-footer">
    <button class="btn btn-primary text-center" (click)="openAddToCartPopupModal()">
      <span>
        Add to cart
        <i *ngIf="isAdding" class="fal fa-spinner rotate ml-2"></i>
      </span>
    </button>
  </div>
</div>
